import store from "stores";

import { isNil, cloneDeep, size, orderBy, sumBy } from 'lodash';

import orgService from "services/Auth.Organization.service";

import { userPriv, userInvalid } from "utils/privilege.util";

import deviceUtil from 'utils/device.util';
import { defaultColumns } from '../const';
import Nuclias from "const/nuclias";
const { organizationType, userType, userPrivilege } = Nuclias;

const iconFormat = {
  online: 0,
  offline: 0,
  dormant: 0
};

const deviceCountList = ['deviceAll', 'ap', 'switch', 'gateway'];

const getInfo = () => {
  const { user: { user }, pageContext } = store.getState();
  const res = { userType: user.type };
  res.isOrgUser = (user.type !== userType.sp && user.type !== userType.si) ? true : false;
  res.orgDs = res.isOrgUser ? pageContext.selectedOrg : pageContext.sp || pageContext.si;
  res.columns = defaultColumns(res);
  return res;
};

const getFilter = (info, pagination, searchParams) => {
  let hasSelf = false;
  const params = {};
  if (size(searchParams) > 0) {
    for (const [key, value] of Object.entries(searchParams)) {
      if (!isNil(value) && value !== '') {
        params[key] = value;
        if (key === 'orgName' && info.orgDs?.name?.toLowerCase()?.indexOf(value.toLowerCase()) !== -1) {
          hasSelf = true;
        }
      }
    }
  }
  if (isNil(searchParams?.orgName)) {
    hasSelf = true;
  }
  const skip = (pagination.current - 1) * pagination.pageLimit; //9
  params.skip = skip > 0 ? skip : 0;
  params.limit = pagination.pageLimit;
  if (hasSelf) {
    if (params.skip === 0) {
      params.limit--;
    } else {
      params.skip--;
    }
  }
  return { params, hasSelf };
};

const getDataList = (info, pagination, searchOrg) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = {}
      let filter = {}
      if (!info.isOrgUser) {
        filter = getFilter(info, pagination, searchOrg);
        const mspData = await mspApi(info, filter);
        res.data = mspData.data;
        res.total = mspData.paging?.total || 0;
      } else {
        const data = await orgWithoutApi(info.orgDs);
        res.data = data;
        res.total = 1;
      }
      Resolve({ res, filter });
    } catch (error) {
      Reject(error);
    }
  });
};

const mspApi = async (info, filter) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const orgId = info.orgDs.id;
      const data = await orgService.getNetworkViewList(orgId, filter.params);
      for (let org of data.data) {
        org.orgTypeLabel = org.orgType === organizationType.si ? 'MSP' : 'ORG';
        org.orgId = org.id
        org.actions = {
          createSite: !userPriv(userPrivilege.manager),
          createTag: !userPriv(userPrivilege.manager),
          canInvite: !userPriv(userPrivilege.manager),
          canDelete: !userPriv(userPrivilege.manager),
          canEdit: !userPriv(userPrivilege.manager),
        }
        for (let site of org.sites) {
          site.deviceAll = {
            online: site.ap.online + site.switch.online + site.gateway.online,
            offline: site.ap.offline + site.switch.offline + site.gateway.offline,
            dormant: site.ap.dormant + site.switch.dormant + site.gateway.dormant,
          };

          const devicesLength = site.deviceAll.online + site.deviceAll.dormant + site.deviceAll.dormant;
          if (devicesLength === 0 || site.deviceAll.dormant === devicesLength) {
            site.status = 'icon-selected-gray';
          } else if (site.deviceAll.online === devicesLength) {
            site.status = 'icon-selected';
          } else {
            site.status = 'icon-selected-red';
          }
        }
      }
      if (filter.params.skip === 0 && filter.hasSelf) {
        const self = {
          name: info.orgDs.name,
          orgType: info.userType === userType.si ? organizationType.si : organizationType.sp,
          orgTypeLabel: info.userType === userType.si ? 'MSP' : 'e1b3ec89ea',
          uid: info.orgDs.uid,
          id: info.orgDs.id,
          siteCount: '',
          siteTagCount: '',
          sites: [],
          actions: {
            createSite: false,
            createTag: false,
            canInvite: !userPriv(userPrivilege.manager),
            canDelete: false,
            canEdit: !userPriv(userPrivilege.manager),
          }
        };
        data.data.unshift(self);
        data.paging.total++;
      }
      Resolve(data);
    } catch (error) {
      Reject(error);
    }
  });
};

const orgWithoutApi = async (orgDs) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = {
        name: orgDs.name,
        orgId: orgDs.id,
        uid: orgDs.uid,
        orgType: organizationType.org,
        orgTypeLabel: 'ORG',
        sites: getSites(orgDs),
        siteTagCount: size(orgDs?.storeTagObj).length || 0,
        actions: {
          createSite: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
          createTag: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
          canInvite: !userPriv(userPrivilege.manager),
          canEdit: !userPriv(userPrivilege.manager) && !userPriv(userType.org),
        }
      };
      res.siteCount = res.sites.length || 0;
      const orgDeviceCal = calOrgDevices(res.sites);

      Resolve([Object.assign({}, res, orgDeviceCal)]);
    } catch (error) {
      Reject(error);
    }
  });
};

const calOrgDevices = (sites) => {
  const res = {};
  for (const itme of deviceCountList) {
    res[itme] = cloneDeep(iconFormat);
    for (const [key, value] of Object.entries(iconFormat)) {
      res[itme][key] = sumBy(sites, `${itme}.${key}`);
    }
  }
  return res;
};

const getSites = (orgDs) => {
  let tmpList = [];
  const dormantUnix = deviceUtil.getDeviceDormantUnix();
  for (const [id, item] of Object.entries(orgDs.storeObj)) {
    const tmp = {
      siteName: item.name,
      siteId: item.id,
      status: '',
      deviceAll: cloneDeep(iconFormat),
      ap: cloneDeep(iconFormat),
      switch: cloneDeep(iconFormat),
      gateway: cloneDeep(iconFormat),
    };

    for (const device of item.devices) {
      if (device.onlineStatus) {
        tmp[device.deviceModel.deviceType.toLowerCase()].online++;
        tmp.deviceAll.online++;
      } else {
        if (device?.lastOnlineTime >= dormantUnix) {
          tmp[device.deviceModel.deviceType.toLowerCase()].offline++;
          tmp.deviceAll.offline++;
        } else {
          tmp[device.deviceModel.deviceType.toLowerCase()].dormant++;
          tmp.deviceAll.dormant++;
        }
      }
    }
    const devicesLength = item?.devices?.length || 0;
    if (devicesLength === 0 || tmp.deviceAll.dormant === devicesLength)
      tmp.status = 'icon-selected-gray';
    else if (tmp.deviceAll.online === devicesLength)
      tmp.status = 'icon-selected';
    else
      tmp.status = 'icon-selected-red';

    tmpList.push(tmp);
  };
  return orderBy(tmpList, [item => item.siteName.toLowerCase()], 'asc');
};

export default {
  getInfo,
  getFilter,
  getDataList
};